import axios from 'axios'
import swal from '../plugins/sweetalert'
import router from '@/router'
import { useLoadingStore } from '../stores/loading'
import { config } from './config'

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: 15000
})

axiosInstance.interceptors.request.use(
  (c) => {
    const loadingStore = useLoadingStore()
    loadingStore.showLoading()
    const token = localStorage.getItem(config.paramBackendToken)
    if (token) {
      c.headers.Authorization = `Bearer ${token}`
    }
    return c
  },
  (error) => {
    const loadingStore = useLoadingStore()
    loadingStore.hideLoading()
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    const loadingStore = useLoadingStore()
    loadingStore.hideLoading()
    const code = response.data.code
    const data = response.data.data
    if (code == '0000') {
      if (process.env.NODE_ENV === 'development') {
        console.log(data)
      }
      return data
    } else if (code === '0001') {
      const liveToast = document.getElementById('liveToast')
      const toastTitle = document.getElementById('toastTitle')
      const toast = new window.bootstrap.Toast(liveToast, { delay: 3000 })
      toastTitle.innerHTML = data
      toast.show()
      return data
    } else if (code === '0002') {
      swal({
        title: '系統訊息',
        html: data,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: '確定'
      })
      return null
    } else if (code === '0003') {
      swal({
        title: '系統訊息',
        html: data,
        icon: 'success',
        showCancelButton: false,
        confirmButtonText: '確定'
      })
      return data
    } else if (code === '0009') {
      //jwt 錯誤或無權限使用
      router.replace({ path: 'error403' })
    } else if (code === '9999') {
      swal({
        title: '系統異常',
        html: data,
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: '確定'
      })
    } else {
      console.error(data)
    }
    return null
  },
  (error) => {
    const loadingStore = useLoadingStore()
    loadingStore.hideLoading()
    return Promise.reject(error)
  }
)

export default axiosInstance
